import { render, staticRenderFns } from "./accessDenied.vue?vue&type=template&id=31361324"
import script from "./accessDenied.vue?vue&type=script&lang=js"
export * from "./accessDenied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports